"use strict";import{css as o}from"@spectrum-web-components/base";const t=o`
.sortedIcon{display:none;margin-inline-end:var(
--mod-table-sort-icon-inline-end-spacing,var(--mod-table-icon-to-text,var(--spectrum-table-icon-to-text))
);margin-inline-start:var(--mod-table-sort-icon-inline-start-spacing,0);transition:transform var(
--highcontrast-table-transition-duration,var(
--mod-table-transition-duration,var(--spectrum-table-transition-duration)
)
) ease-in-out;vertical-align:baseline}:host{--spectrum-table-icon-color:var(
--highcontrast-table-icon-color,var(
--mod-table-icon-color-default,var(--spectrum-table-icon-color-default)
)
);background-color:var(
--mod-table-header-background-color,var(--spectrum-table-header-background-color)
);block-size:var(
--mod-table-min-header-height,var(--spectrum-table-min-header-height)
);border-radius:0;box-sizing:border-box;color:var(
--mod-table-header-text-color,var(--spectrum-table-header-text-color)
);cursor:var(--mod-table-cursor-header-default,initial);font-family:var(
--mod-table-header-font-family,var(--spectrum-table-row-font-family)
);font-size:var(
--mod-table-header-font-size,var(--spectrum-table-row-font-size)
);font-weight:var(
--mod-table-header-font-weight,var(--spectrum-table-header-font-weight)
);line-height:var(
--mod-table-header-line-height,var(--spectrum-table-row-line-height)
);outline:0;padding-block:var(
--mod-table-header-top-to-text,var(--spectrum-table-header-top-to-text)
) var(
--mod-table-header-bottom-to-text,var(--spectrum-table-header-bottom-to-text)
);padding-inline:var(
--mod-table-cell-inline-space,var(--spectrum-table-cell-inline-space)
);text-align:start;text-transform:var(--mod-table-header-text-transform,none);transition:color var(
--highcontrast-table-transition-duration,var(
--mod-table-transition-duration,var(--spectrum-table-transition-duration)
)
) ease-in-out;vertical-align:var(
--mod-table-header-vertical-align,var(--spectrum-table-header-vertical-align)
)}.sortedIcon,.spectrum-Table-menuIcon{color:var(--spectrum-table-icon-color)}:host([sortable]){cursor:var(--mod-table-cursor-header-sortable,pointer)}:host([sortable]:hover){--spectrum-table-icon-color:var(
--highcontrast-table-icon-color-focus,var(
--mod-table-icon-color-hover,var(--spectrum-table-icon-color-hover)
)
)}:host([sortable][active]){--spectrum-table-icon-color:var(
--highcontrast-table-icon-color-focus,var(
--mod-table-icon-color-active,var(--spectrum-table-icon-color-active)
)
)}:host([sortable]:focus){--spectrum-table-icon-color:var(
--highcontrast-table-icon-color-focus,var(
--mod-table-icon-color-focus,var(--spectrum-table-icon-color-focus)
)
)}:host([sortable]:focus):hover{--spectrum-table-icon-color:var(
--highcontrast-table-icon-color-focus,var(
--mod-table-icon-color-focus-hover,var(--spectrum-table-icon-color-focus-hover)
)
)}:host([sortable]) .is-keyboardFocused,:host([sortable].focus-visible){--spectrum-table-icon-color:var(
--highcontrast-table-icon-color-focus,var(
--mod-table-icon-color-key-focus,var(--spectrum-table-icon-color-key-focus)
)
)}:host([sortable]) .is-keyboardFocused,:host([sortable]:focus-visible){--spectrum-table-icon-color:var(
--highcontrast-table-icon-color-focus,var(
--mod-table-icon-color-key-focus,var(--spectrum-table-icon-color-key-focus)
)
)}:host([sort-direction=asc]) .sortedIcon,:host([sort-direction=desc]) .sortedIcon{display:inline-block}:host([sort-direction=asc]) .sortedIcon{transform:rotate(-90deg)}:host{position:relative}:host(.focus-visible),:host([focused]){outline-color:var(
--highcontrast-table-cell-focus-indicator-color,var(
--highcontrast-table-focus-indicator-color,var(
--mod-table-focus-indicator-color,var(--spectrum-table-focus-indicator-color)
)
)
);outline-offset:calc(var(
--mod-table-focus-indicator-thickness,
var(--spectrum-table-focus-indicator-thickness)
)*-1 - var(--highcontrast-table-cell-focus-extra-offset, 0px));outline-style:solid;outline-width:var(
--mod-table-focus-indicator-thickness,var(--spectrum-table-focus-indicator-thickness)
)}:host(.focus-visible),:host([focused]){outline-color:var(
--highcontrast-table-cell-focus-indicator-color,var(
--highcontrast-table-focus-indicator-color,var(
--mod-table-focus-indicator-color,var(--spectrum-table-focus-indicator-color)
)
)
);outline-offset:calc(var(
--mod-table-focus-indicator-thickness,
var(--spectrum-table-focus-indicator-thickness)
)*-1 - var(--highcontrast-table-cell-focus-extra-offset, 0px));outline-style:solid;outline-width:var(
--mod-table-focus-indicator-thickness,var(--spectrum-table-focus-indicator-thickness)
)}:host(:focus-visible),:host([focused]){outline-color:var(
--highcontrast-table-cell-focus-indicator-color,var(
--highcontrast-table-focus-indicator-color,var(
--mod-table-focus-indicator-color,var(--spectrum-table-focus-indicator-color)
)
)
);outline-offset:calc(var(
--mod-table-focus-indicator-thickness,
var(--spectrum-table-focus-indicator-thickness)
)*-1 - var(--highcontrast-table-cell-focus-extra-offset, 0px));outline-style:solid;outline-width:var(
--mod-table-focus-indicator-thickness,var(--spectrum-table-focus-indicator-thickness)
)}:host .spectrum-Table-checkboxCell .spectrum-Table-checkbox{margin-block-end:var(
--mod-table-header-checkbox-block-spacing,var(--spectrum-table-header-checkbox-block-spacing)
);margin-block-start:calc(var(
--mod-table-header-checkbox-block-spacing,
var(--spectrum-table-header-checkbox-block-spacing)
) - var(--mod-table-border-width, var(--spectrum-table-border-width)))}:host{display:table-cell}:host .spectrum-Table-scroller{border-block-end:var(
--mod-table-border-width,var(--spectrum-table-border-width)
) solid var(
--highcontrast-table-border-color,var(--mod-table-border-color,var(--spectrum-table-border-color))
)}:host{block-size:auto;display:block;flex:1}
`;export default t;
//# sourceMappingURL=table-head-cell.css.js.map
